import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsMultiNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M18 14.487L15.292 19H13v2.5h3.708L18 19.346l4 6.667 2.708-4.513H27V19h-3.708L22 21.154z" />
        <path d="M22.247 5.753A11.993 11.993 0 0012 0C5.373 0 0 5.373 0 12c0 4.339 2.303 8.14 5.752 10.247a12.06 12.06 0 004 4A11.993 11.993 0 0020 32c6.627 0 12-5.373 12-12 0-4.339-2.303-8.14-5.753-10.248a12.061 12.061 0 00-4-4zM12 2.5c1.928 0 3.722.574 5.22 1.561C16.819 4.021 16.412 4 16 4 9.373 4 4 9.373 4 16c0 .412.02.819.061 1.22A9.455 9.455 0 012.5 12 9.5 9.5 0 0112 2.5zM8 20c0 .412.02.819.061 1.22A9.456 9.456 0 016.5 16 9.5 9.5 0 0116 6.5c1.928 0 3.722.574 5.22 1.561C20.819 8.021 20.412 8 20 8 13.373 8 8 13.373 8 20zm12-9.5a9.5 9.5 0 110 19 9.5 9.5 0 010-19z" />
      </g>
    </svg>
  )
);
SvgSportsMultiNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsMultiNormalMedium;
